(() => {
  let updating = false;
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-remove-coupon]');
    if (!button || updating) return;
    event.preventDefault();
    const root = window.Shopify?.routes?.root || '/';
    const code = button.dataset.removeCoupon.toLowerCase();
    const scope = button.closest('[data-cart-drawer], [data-main-cart]');
    const container = button.closest('.cart-discounts');
    const errorMessage = container.querySelector('[data-coupon-error]');
    const surfaces = [...document.querySelectorAll('[data-cart-drawer], [data-main-cart]')];
    updating = true;
    errorMessage.textContent = '';
    surfaces.forEach(surface => { surface.inert = true; surface.setAttribute('aria-busy', 'true'); });
    try {
      const currentResponse = await fetch(`${root}cart.js`, { cache: 'no-store' });
      if (!currentResponse.ok) throw new Error('Cart unavailable');
      const current = await currentResponse.json();
      // Read current server codes, preserving other coupons (including shipping codes).
      const codes = current.discount_codes
        ? current.discount_codes.map(discount => discount.code)
        : [...document.querySelectorAll('[data-applied-discount-code]')].map(element => element.dataset.appliedDiscountCode);
      const remaining = [...new Set(codes)].filter(value => value.toLowerCase() !== code);
      const ids = surfaces.map(surface => surface.dataset.sectionId);
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: remaining.join(','), sections: ids, sections_url: `${root}cart` })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error('Coupon update failed');
      // Validate every section before replacing either cart.
      const replacements = surfaces.map(surface => {
        const html = cart.sections?.[surface.dataset.sectionId];
        if (!html) throw new Error('Cart section unavailable');
        const selector = surface.matches('[data-cart-drawer]') ? '.cart-drawer__panel' : '[data-main-cart]';
        const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
        if (!replacement) throw new Error('Cart markup unavailable');
        return { target: selector === '.cart-drawer__panel' ? surface.querySelector(selector) : surface, replacement };
      });
      replacements.forEach(({ target, replacement }) => { target.innerHTML = replacement.innerHTML; });
      const scope = button.closest('[data-cart-drawer]') || button.closest('[data-main-cart]');
      // The clicked button was detached during rendering; restore focus within the same surface.
      const focusSurface = scope || surfaces.find(surface => surface.classList.contains('is-open')) || surfaces.find(surface => surface.matches('[data-main-cart]'));
      surfaces.forEach(surface => { surface.inert = false; });
      (focusSurface?.querySelector('[data-remove-coupon], [data-promo-toggle], .main-cart__checkout, .cart-drawer__close'))?.focus();
    } catch (error) {
      errorMessage.textContent = container.dataset.errorMessage;
      console.error('Coupon removal failed:', error);
    } finally {
      surfaces.forEach(surface => { surface.inert = false; surface.removeAttribute('aria-busy'); });
      updating = false;
    }
  });
})();
